module.exports = __webpack_public_path__ + "static/media/Cart_Logo.40d9dc57.svg";